module.exports = __webpack_public_path__ + "img/services_ecommerce.ba0c6061.png";